export default "__VITE_ASSET__XECvTwmW__"